import React from 'react';
import { useSelector } from 'react-redux';
import { Stack, Typography } from '@mui/material';
import { AppColors } from '../../Utils/helper/AppColors';
import CustomTag from '../../Components/CustomTag';
import { getColorSettings } from '../../Utils/helper/commonUtils';

const TAG_KEYS = [
    { key: 'total', label: 'Total', type: '1' },
    { key: 'scheduled', label: 'Scheduled', type: '2' },
    { key: 'rescheduled', label: 'Rescheduled', type: '3' },
    { key: 'completed', label: 'Completed', type: '4' },
    { key: 'pending', label: 'Pending', type: '5' },
];

    const localSettingColors = getColorSettings();



export default function ReportCallDetailsSummary({data ,selectedType ,setSelectedType}) {

    // console.log("data", data);

    if (!data || Object.keys(data).length === 0) return null;

    return (
        <Stack direction="row" sx={{ marginTop: 2, marginBottom: 1, gap: 2 , justifyContent: 'flex-end' }}>
            {TAG_KEYS.map(({ key, label, type }) => (
                <CustomTag
                    key={key}
                    tagTitle={`${label} : ${data[key] ?? 0}`}
                    colorsInfo={ key === selectedType && { bgColor: localSettingColors.buttonBackground, color: localSettingColors.quinary, border: localSettingColors.quaternary } }
                    cursor='pointer'
                    onClick={() => setSelectedType && setSelectedType(key)}
                />
            ))}
        </Stack>
    );
}